import { render, staticRenderFns } from "./select-monitor.vue?vue&type=template&id=523c94d4&scoped=true"
import script from "./select-monitor.vue?vue&type=script&lang=js"
export * from "./select-monitor.vue?vue&type=script&lang=js"
import style0 from "./select-monitor.vue?vue&type=style&index=0&id=523c94d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c94d4",
  null
  
)

export default component.exports